const io = require('socket.io-client');
const feathers = require('@feathersjs/feathers');
const socketio = require('@feathersjs/socketio-client');
const auth = require('@feathersjs/authentication-client');

export const EXCHANGE_API = process.env.REACT_APP_EXCHANGE_API;
export const TICKER_API = process.env.REACT_APP_TICKER_API;
export const CRM = process.env.REACT_APP_CRM;
export const STORAGE_URL = process.env.REACT_APP_STORAGE_API;

export const EMAIL_API = process.env.REACT_APP_EMAIL_API;
export const BROKER_EMAIL = process.env.REACT_APP_BROKER_EMAIL;
export const BASE_URL = process.env.REACT_APP_BASE_URL;

const socket = io(EXCHANGE_API);

const app = feathers();
app.configure(auth({
    strategy: 'jwt',
    storage: window.localStorage
}));
app.configure(socketio(socket, {timeout:40000}));

function isEmpty(str) {
    return (!str || 0 === str.length);
}

export const API = app;
export const SOCKET = socket;

export async function reAuth() {
    return new Promise(function (resolve, reject) {
        if(!isEmpty(window.localStorage.getItem('feathers-jwt'))) {
            app.authenticate({
                strategy: 'jwt',
                accessToken: window.localStorage.getItem('feathers-jwt')
            }).then((response)=>{
                app.passport.verifyJWT(response.accessToken).then((data)=>{
                    app.service('users').get(data.userId).then((u)=>{
                        resolve(u);
                    });
                })
            }).catch((e)=>{
                reject(Error("Not Authenticated"));    
            })
        } else {
            reject(Error("Not Authenticated"));
        }
    })
};

export function populateRole(userType){
    if(userType === "admin") {
        return ['admin'];
    } else {
        return ['guest']
    }
}

export function CONSOLE(output){
    if(process.env.NODE_ENV !== 'production'){
        console.log(output)
    }
}



// WEBPACK FOOTER //
// ./src/config.js